@let parentCategoriesValue = currentParentCategories();
@let subcategoriesValue = currentSubcategories();

<div class="main-content content-with-side-menu" [formGroup]="form">
    <h1 class="page-header">
        <app-go-back></app-go-back> {{ 'CampCreate.Title' | translate }}
        <button class="btn btn-success right btn-header" bcClick hznTestId="camp-create-save" (clicked)="create()">{{ 'CampCreate.Save' | translate }}</button>
    </h1>

    <div>
        <div class="card">
            <div class="card-body">
                <h5 class="card-title main-blue">{{ 'CampCreate.BasicPanelTitle' | translate }}</h5>
                <div class="card-text">
                    <div class="row form-group form-horizontal">
                        <div class="col-sm-2 bolded">{{ 'CampCreate.Name' | translate }}</div>
                        <div class="col-sm-10">
                            <input placeholder="Type your new camp unique name" class="form-control" hznTestId="camp-create-name" formControlName="name" maxlength="160" />
                        </div>
                    </div>
                    <div class="row form-group form-horizontal">
                        <div class="col-sm-2 bolded">{{ 'CampCreate.Type' | translate }}</div>
                        <div class="col-sm-10">
                            <select hznTestId="camp-create-type" (change)="changeType($event.target.value)" class="form-control">
                                @for (type of campTypes; track $index) {
                                    <option [value]="type" [selected]="form.controls.campType.value == type">{{ translateType(type) }}</option>
                                }
                            </select>
                        </div>
                    </div>
                </div>

                <app-camp-category-edit [form]="categoryForm" [parentCategories]="parentCategoriesValue" [subcategories]="subcategoriesValue"></app-camp-category-edit>
            </div>
        </div>
    </div>
</div>
